<template>
  <div class="container" style="height: 100%">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <p class="title">{{ info.name }}</p>
        <p style="margin-top: 5px">
          <span class="time">{{
            formatDate(info.startTime, "MM-DD HH:mm")
          }}</span>
          <span class="shu">|</span>
          <span>已评：{{ list.length }}</span>
          <span class="shu">|</span>
          <span class="surplus" v-show="info.autoStop && info.status != 'STOP'"
            >剩余<i class="el-icon-time"></i>{{ surplus }}</span
          >
          <span class="end" v-show="info.status == 'STOP'">已结束</span>
        </p>
        <div class="right_btns">
          <el-button type="text">导出数据</el-button>
          <el-button
            type="text"
            v-show="info.status != 'STOP'"
            @click="handleStop"
            >结束活动</el-button
          >
        </div>
      </div>
    </div>
    <div class="main">
      <div class="list">
        <p class="info-row">
          平均分：<b>{{ average }}</b> 分
        </p>

        <div class="list-box">
          <div class="list-row" v-for="item in list" :key="item.id">
            <el-image class="img" :src="item.avatar" fit="cover"></el-image>
            <div class="right">
              <p>
                <span class="row-name">{{ item.name }}</span>
                <span class="row-score"
                  >评分：<b>{{ item.score }}</b> 分</span
                >
              </p>
              <p class="row-content">{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import mixinsData from "../mixins/detail";
import { formatDate } from "@/utils/index";
export default {
  name: "sign",
  //   mixins: [mixinsData],
  data() {
    return {
      formatDate,
      info: {
        name: "评分哦",
        autoStop: true,
        status: "STARTED",
      },
      list: [
        {
          id: 1,
          name: "章三",
          avatar: require("@/assets/images/icons/icon_me.png"),
          score: 90,
          content: "我认为太好了",
        },
        {
          id: 2,
          name: "里斯",
          avatar: require("@/assets/images/icons/icon_me.png"),
          score: 95,
          content: "我也认为太好了",
        },
      ],
      surplus: "20分钟",
    };
  },
  computed: {
    average() {
      if (this.list.length <= 0) return 0;
      else
        return (
          this.list.reduce((prev, curr) => {
            return curr.score + prev;
          }, 0) / this.list.length
        );
    },
  },
  methods: {
    // 签到列表
    getList() {
      let activityId = this.$route.query.activityId;
      // this.$loading.show();
      signList({ activityId }).then((res) => {
        // this.$loading.hide();
        if (res.code == 0) {
          this.signedList = res.data.filter((item) => {
            return item.status == "SIGNED";
          });
          this.notList = res.data.filter((item) => {
            return item.status != "SIGNED";
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    handleStop() {},
    back() {
      this.$store.commit("SET_UPDATE", true);
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
  .back_box {
    display: inline-block;
    width: calc(100% - 1126px);
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    img {
      width: 44px;
    }
    p {
      color: #969696;
      font-size: 16px;
    }
  }
  .info {
    position: relative;
    display: inline-block;
    padding: 24px 30px;
    background-color: #fff;
    width: 1126px;
    vertical-align: middle;
    .title {
      font-size: 16px;
      color: #333;
    }
    .time {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
    }

    .shu {
      padding: 0 10px;
      color: #ddd;
    }
    .el-icon-time {
      margin: 0 5px;
    }
    .surplus {
      color: sandybrown;
    }
    .end {
      color: #999;
    }
    .right_btns {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
    }
  }
}

.main {
  position: relative;
  height: calc(100% - 30px - 20px - 88px - 30px);
  background-color: #fff;
  text-align: left;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
  }

  .list {
    .info-row {
      padding: 20px;
      border-bottom: solid 1px #ddd;
    }
    .list-box {
      .list-row {
        padding: 30px;
        border-bottom: solid 1px #eee;
        .img {
          margin-right: 20px;
          width: 45px;
          height: 45px;
        }
        .right {
          display: inline-block;
          width: calc(100% - 65px);
          vertical-align: top;
          overflow: hidden;
          .row-name {
            color: #606266;
          }
          .row-score {
            float: right;
            color: #409eff;
          }
          .row-content {
            margin-top: 10px;
            // text-indent: 2em;
          }
        }
      }
    }
  }
}
</style>